import { api } from "@/redux/api";

import {
	OnboardingTourState,
	OnboardingTourStateSchema,
	UpdateListTourRequest,
	UpdateListTourSchema,
	UpdateOnboardingTourProgressRequest,
	UpdateOnboardingTourProgressSchema,
} from "./schema";

export const onboardingTourApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getOnboardingTour: builder.query<OnboardingTourState, void>({
			query: () => ({
				url: "onboarding-tour",
				responseSchema: OnboardingTourStateSchema,
			}),
			providesTags: ["OnboardingTour"],
		}),
		updateOnboardingTourProgress: builder.mutation<
			OnboardingTourState,
			UpdateOnboardingTourProgressRequest
		>({
			query: (body) => ({
				url: "onboarding-tour/progress",
				method: "PATCH",
				body,
				requestSchema: UpdateOnboardingTourProgressSchema,
				responseSchema: OnboardingTourStateSchema,
			}),
		}),
		skipOnboardingTour: builder.mutation<OnboardingTourState, void>({
			query: () => ({
				url: "onboarding-tour/skip",
				method: "POST",
				responseSchema: OnboardingTourStateSchema,
			}),
			invalidatesTags: ["OnboardingTour"],
		}),
		markNudgeShown: builder.mutation<OnboardingTourState, void>({
			query: () => ({
				url: "onboarding-tour/nudge-shown",
				method: "POST",
				responseSchema: OnboardingTourStateSchema,
			}),
			invalidatesTags: ["OnboardingTour"],
		}),
		exploreOnboardingTour: builder.mutation<OnboardingTourState, void>({
			query: () => ({
				url: "onboarding-tour/explore",
				method: "POST",
				responseSchema: OnboardingTourStateSchema,
			}),
			invalidatesTags: ["OnboardingTour"],
		}),
		updateListTour: builder.mutation<OnboardingTourState, UpdateListTourRequest>({
			query: (body) => ({
				url: "onboarding-tour/list-tour",
				method: "PATCH",
				body,
				requestSchema: UpdateListTourSchema,
				responseSchema: OnboardingTourStateSchema,
			}),
		}),
		retryKnowledgeBase: builder.mutation<OnboardingTourState, void>({
			query: () => ({
				url: "onboarding-tour/knowledge/retry",
				method: "POST",
				responseSchema: OnboardingTourStateSchema,
			}),
			invalidatesTags: ["OnboardingTour"],
		}),
		// Reaching "Check & activate" starts the configured lists, once per company (PREC-4490).
		reachOnboardingTourCheck: builder.mutation<OnboardingTourState, void>({
			query: () => ({
				url: "onboarding-tour/check-reached",
				method: "POST",
				responseSchema: OnboardingTourStateSchema,
			}),
		}),
		completeOnboardingTour: builder.mutation<OnboardingTourState, void>({
			query: () => ({
				url: "onboarding-tour/complete",
				method: "POST",
				responseSchema: OnboardingTourStateSchema,
			}),
			invalidatesTags: ["OnboardingTour"],
		}),
	}),
});

export const {
	useGetOnboardingTourQuery,
	useUpdateOnboardingTourProgressMutation,
	useSkipOnboardingTourMutation,
	useMarkNudgeShownMutation,
	useExploreOnboardingTourMutation,
	useUpdateListTourMutation,
	useRetryKnowledgeBaseMutation,
	useReachOnboardingTourCheckMutation,
	useCompleteOnboardingTourMutation,
} = onboardingTourApi;
